import { useEffect, useMemo, useState } from 'react';

import { useDispatch } from 'react-redux';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';

import Spinner from '../../components/common/Spinner';

import { getSubCategoryWithQuestion, searchQuestion } from './helpDesk.actions';

import {
  BreadCrumbs,
  HelpDeskContainer,
  SearchContainer,
  SearchInput,
  TopicCategory,
  TopicCategoryTitle
} from './HelpDeskStyled';

import { useTranslation } from 'react-i18next';
import { HELPDESK_QUESTION } from '../../routes/routes';
import { colors } from '../../styles/GlobalStyles';
import { Icon, IconSearch } from '../../styles/Icons';
import { SearchDropdown } from './SearchDropdown';

import debouce from 'lodash.debounce';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components';
import { clearQuestions } from '../../slices/help-desk-slice';

type TParams = { subId?: string };

export const SubCategory = (props: RouteComponentProps<TParams>) => {
  const { t } = useTranslation('helpdesk');
  const [close] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useAppDispatch();
  const history = useHistory();

  const onChange = (e: any) => {
    if (e.target.value.length > 0) {
      dispatch(searchQuestion(e.target.value));
    } else {
      dispatch(clearQuestions());
    }
  };

  const debouncedResults = useMemo(() => {
    return debouce(onChange, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  const { subCategory, category, questions, loading } = useAppSelector(
    (state) => state.helpDesk
  );

  useEffect(() => {
    if (props.match.params.subId) {
      dispatch(getSubCategoryWithQuestion(props.match.params.subId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard dark>
      <div style={{ width: '100%' }}>
        <SearchContainer close={close}>
          <Icon mr='15' color={colors.neutral700}>
            <IconSearch />
          </Icon>
          <SearchInput
            type='text'
            onChange={debouncedResults}
            onFocus={() => setIsOpen(true)}
            placeholder={t('search_articles_placeholder')}
          />
          <SearchDropdown
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            questions={questions}
            category={category}
          />
        </SearchContainer>

        <HelpDeskContainer close={close}>
          <TopicCategory>
            <BreadCrumbs>
              <span
                onClick={() => history.goBack()}
                style={{ cursor: 'pointer' }}>
                {category?.name}{' '}
              </span>
              <span style={{ margin: '0 10px' }}>{' > '}</span>{' '}
              {subCategory?.name}
            </BreadCrumbs>
            <TopicCategoryTitle>
              <h1>{subCategory?.name}</h1>
            </TopicCategoryTitle>

            <>
              {subCategory?.questions?.map((question, i) => (
                <Link
                  to={`${HELPDESK_QUESTION}/${question.id}/${category?.id}/${subCategory.id}`}
                  key={i}>
                  <li>{question.question}</li>
                </Link>
              ))}
            </>
          </TopicCategory>
        </HelpDeskContainer>
      </div>
    </AnimatedDashboard>
  );
};
